import {Plus, Upload, X} from "lucide-react";
import Dropdown from "../../Component/Dropdown/Drowdown";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import apiRequests from "../../Component/axios/config/config";
import toast from "react-hot-toast";
import axios from "axios";
import { FiTrash2 } from "react-icons/fi";


export default function CategoryCreate() {


    const navigate = useNavigate();

    const [loadingImage, setLoadingImage] = useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [imageUrl, setImageUrl] = useState("");


    const [formData, setFormData] = useState({
        name: "",
        fa_name: "",
        fr_name: "",
        de_name: "",
        zh_name: "",
        image: "",
        specifications: {}
    });

    const addSpecification = () => {
        setFormData(prev => ({
            ...prev,
            specifications: {
                ...prev.specifications,
                [""]: ""
            }
        }));
    };

    const updateSpecKey = (oldKey, newKey) => {
        if (!newKey) return;

        setFormData(prev => {
            const updated = { ...prev.specifications };
            updated[newKey] = updated[oldKey];
            delete updated[oldKey];

            return {
                ...prev,
                specifications: updated
            };
        });
    };

    const updateSpecValue = (key, value) => {
        setFormData(prev => ({
            ...prev,
            specifications: {
                ...prev.specifications,
                [key]: value
            }
        }));
    };

    const removeSpecification = (key) => {
        setFormData(prev => {
            const updated = { ...prev.specifications };
            delete updated[key];

            return {
                ...prev,
                specifications: updated
            };
        });
    };


    function readImage() {
        document.querySelector('#profile')?.click();
    }

    function UploadImage(e) {

        const formData = new FormData();
        formData.append('file', e.target.files[0]);

        setLoadingImage(true)
        axios.post(`https://api.goalafarin.com/api/file/v1/upload-admin`, formData, {
            headers: {
                authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            toast.success("Upload Image successfully");
            setImageUrl(URL.createObjectURL(e.target.files[0]));
            setFormData(prevFormData => ({
                ...prevFormData,
                image: response.data.message._id,
            }))
        }).catch((error) => {
            if (error.status === 401 || error.status === 403) {
                navigate("/login");
            }
        }).finally(() => {
            setLoadingImage(false)
        })
    }


    function createCategory() {

        if (formData.name === "" || formData.fa_name === "" || formData.fr_name === "" || formData.de_name === "" || formData.zh_name === "" || formData.specifications === "" || formData.image === "") {
            return toast.error("Fill all Fields");
        }

        const payload = {
            name: formData.name,
            fa_name: formData.fa_name,
            fr_name: formData.fr_name,
            de_name: formData.de_name,
            zh_name: formData.zh_name,
            specifications: formData.specifications,
            order: 1,
            ...(formData.image && { image: formData.image })
        };


        setIsLoading(true)
        apiRequests.post("/api/category/create-admin", payload)
            .then((response) => {
                toast.success(response.data.en_message);
                setFormData({
                    name: "",
                    fa_name: "",
                    fr_name: "",
                    de_name: "",
                    zh_name: "",
                    image: "",
                    specifications: {},
                })
                setImageUrl("")
                navigate("/category")
            })
            .catch((error) => {
                if (error.status === 401 || error.status === 403) {
                    navigate("/login");
                }
            })
            .finally(() => setIsLoading(false))


    }


    return (

        <div className="min-h-screen bg-gray-50 p-6">
            <div className="max-w-4xl mx-auto">

                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-2xl font-bold">Create New Category</h1>
                    <button
                        onClick={() => navigate(-1)}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <X size={24}/>
                    </button>
                </div>


                <div className="bg-white p-6 rounded-xl shadow-sm">


                    <div className="mt-6">
                        <label className="block mb-2 font-medium">Category Images *</label>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">

                            {imageUrl &&
                                <div className="relative group">
                                    <img
                                        src={imageUrl}
                                        alt="Preview"
                                        className="h-32 w-full object-cover rounded-lg border"
                                    />

                                    <button
                                        type="button"
                                        onClick={() => {
                                            setFormData({...formData, image: ""})
                                            setImageUrl('')
                                        }}
                                        className="absolute top-2 right-2 bg-white/80 p-1 rounded-full hover:bg-red-100"
                                    >
                                        <FiTrash2 className="w-4 h-4 text-red-600" />
                                    </button>

                                </div>
                            }


                            {!Boolean(formData.image) &&

                                <label
                                    className="h-32 border-2 border-dashed rounded-lg flex items-center justify-center cursor-pointer hover:border-indigo-500">
                                    {!loadingImage &&
                                        <input
                                            type="file" accept="image/*"
                                            onClick={() => readImage()}
                                            onChange={UploadImage}
                                            className="hidden"
                                        />
                                    }

                                    <div className="text-center text-gray-500">
                                        {loadingImage ?

                                            <div className="mx-auto mb-2">
                                                <svg aria-hidden="true"
                                                     className="inline w-5 h-5 text-white animate-spin dark:text-gray-600 fill-white"
                                                     viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                        fill="currentColor"/>
                                                    <path
                                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                        fill="currentFill"/>
                                                </svg>

                                            </div>
                                            :
                                            <Upload className="mx-auto mb-2"/>
                                        }

                                        <span>
                                        {loadingImage ?
                                            "Uploading..."
                                            :
                                            "Upload Images"
                                        }

                                    </span>
                                    </div>
                                </label>

                            }



                        </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                        <div>
                            <label className="block mb-2 font-medium">Category Name ( English )</label>
                            <input
                                type="text"
                                required
                                placeholder="enter name"
                                className="w-full p-2 border rounded-lg"
                                value={formData.name}
                                onChange={e => setFormData({...formData, name: e.target.value})}
                            />
                        </div>


                        <div>
                            <label className="block mb-2 font-medium">Category Name ( Persian ) </label>
                            <input
                                type="text"
                                required
                                placeholder="enter name"
                                className="w-full p-2 border rounded-lg"
                                value={formData.fa_name}
                                onChange={e => setFormData({...formData, fa_name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium">Category Name ( France ) </label>
                            <input
                                type="text"
                                required
                                placeholder="enter name"
                                className="w-full p-2 border rounded-lg"
                                value={formData.fr_name}
                                onChange={e => setFormData({...formData, fr_name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium">Category Name ( China ) </label>
                            <input
                                type="text"
                                required
                                placeholder="enter name"
                                className="w-full p-2 border rounded-lg"
                                value={formData.zh_name}
                                onChange={e => setFormData({...formData, zh_name: e.target.value})}
                            />
                        </div>

                        <div>
                            <label className="block mb-2 font-medium">Category Name ( Germany ) </label>
                            <input
                                type="text"
                                required
                                placeholder="enter name"
                                className="w-full p-2 border rounded-lg"
                                value={formData.de_name}
                                onChange={e => setFormData({...formData, de_name: e.target.value})}
                            />
                        </div>


                    </div>

                    <div className="mt-6">
                        <label className="block mb-2 font-medium">Specifications</label>

                        <div className="space-y-3">
                            {Object.entries(formData.specifications).map(([key, value], index) => (
                                <div key={index} className="flex gap-2 items-center">
                                    <input
                                        type="text"
                                        placeholder="Key (e.g. color)"
                                        className="w-1/3 p-2 border rounded-lg"
                                        value={key}
                                        onChange={(e) => updateSpecKey(key, e.target.value)}
                                    />

                                    <input
                                        type="text"
                                        placeholder="Value (e.g. red)"
                                        className="w-1/3 p-2 border rounded-lg"
                                        value={value}
                                        onChange={(e) => updateSpecValue(key, e.target.value)}
                                    />

                                    <button
                                        type="button"
                                        onClick={() => removeSpecification(key)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        <FiTrash2 size={18} />
                                    </button>
                                </div>
                            ))}
                        </div>

                        <button
                            type="button"
                            onClick={addSpecification}
                            className="mt-3 flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"
                        >
                            <Plus size={16} />
                            Add Specification
                        </button>
                    </div>


                    <div className="mt-8 pt-6 border-t flex justify-end gap-4">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="px-6 py-2 bg-gray-100 rounded-lg hover:bg-gray-200"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isLoading}
                            className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center gap-2"
                            onClick={createCategory}
                        >
                            {isLoading ? (
                                <span className="animate-pulse">Creating...</span>
                            ) : (
                                <>
                                    <Plus size={18}/>
                                    Create Category
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}